// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1I_T7","search":"Settings_search__lVbUX","filter":"Settings_filter__VWTj_"};